// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Condition comparison operator for `InFlight` field-path matching.
 */
export enum ConditionOp {
  EQ = 0,
  NOT_EQ = 1,
  LT = 2,
  GT = 3,
  EXISTS = 4,
}
